export default __webpack_public_path__ + "9d032afcd7fafe729a57d869bd3a0c16.png";